import styled, {css} from 'styled-components'

import { fontSizeM, fontSizeS, fontSizeXS, ColorGreyLight, ColorGreyDark, gridGap, colorOrange } from './sharedStyles'


const DefaultGridDiv = styled.div`
    background: white;
    display: grid;
    grid-gap: ${gridGap};
    color: ${ColorGreyDark};
    ${'' /* border: 1px solid steelblue; */}
`

const DefaultFlexDiv = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    color: ${ColorGreyDark};

    ${'' /* border: 1px dashed #333; */}
`

//@todo CHANGE GRID SETUP
export const MainDiv = styled(DefaultGridDiv)`
    width: 100vw;
    height: 80rem;

    grid-template-columns: 1fr minmax(700px, 1400px) 1fr;
    grid-template-rows: 1rem 78rem 1rem;
    grid-template-areas:    ". . ."
                            ". content ."
                            ". . ."
`

export const MainChartContainer = styled(DefaultGridDiv)`
    grid-template-columns: repeat(2, 1fr);
    grid-area: content;
`

export const FiltersContainerMain = styled(DefaultGridDiv)`
    grid-template-rows: 25rem 8rem 45rem;
    grid-gap: 0rem;
`
export const MetricsContainer = styled(DefaultGridDiv)`
    grid-template-columns: 3fr 7fr;
    grid-template-rows: 5rem 1fr; 
    grid-template-areas:    "title search"
                            "cont cont";
    grid-gap: 1rem;
`
export const MetricsTitle = styled(DefaultFlexDiv)`
    font-size: ${fontSizeM};
    justify-content: flex-end;
    grid-area: title;

`
export const MetricsSearch = styled(DefaultFlexDiv)`
    font-size: ${fontSizeS};
    justify-content: flex-end;
    grid-area: search;
    padding-bottom: .5rem;
    position: relative;


    input {
        height: 3rem;
        border-radius: 2rem;
        border: 1px solid ${ColorGreyLight};
        outline: none;
        font-size: ${fontSizeS};
        padding-left: 1rem;
        font-family: neue-kabel, sans-serif;
        font-weight: 200;
        align-self: stretch;
        color: ${ColorGreyDark};
        transition: border .3s;

        &::placeholder {
            opacity: 1;
            color: ${ColorGreyDark};
        }
        &:focus + .search-icon {
            fill: ${ColorGreyLight};
        }

        &:focus {
            border: 1px solid ${ColorGreyDark};

            &::placeholder {
                opacity: 1;
                color: ${ColorGreyLight};
            }

        }
    }

    .search-icon {
        position: absolute;
        fill: ${ColorGreyDark};
        top: 2rem;
        right: 1rem;
        z-index: 10;
        height: 2rem;
        width: 2rem;
        transition: fill .3s;
    }


`
export const Metrics = styled(DefaultFlexDiv)`
    font-size: ${fontSizeS};
    grid-area: cont;
    align-content: flex-start;
    flex-wrap: wrap;
    flex-direction: row;
    overflow-y: scroll;
    border: 1px solid ${ColorGreyLight};
    border-radius: .25rem;
    padding: 1rem;

    background-color: #fff;
    ${'' /* ${props => props.isDraggingOver && css`
        background-color: #a1dd70;
    `} */}
    transition: background-color .5s;
`
export const MetricsElement = styled(DefaultFlexDiv)`
    flex-direction: row;
    background-color: ${ColorGreyLight};
    cursor: pointer;
    font-size: ${fontSizeXS};
    align-items: center;
    border-radius: 2rem;
    vertical-align: middle;
    justify-content: flex-start;
    height: 3rem;
    margin: .4rem .4rem;

    &:hover > .chip-head  {
        .icon{
            fill: #fff;
        }
    }

    .chip-head {
        display: flex;
        position: relative;
        overflow: hidden;
        background-color: ${props => props.chipColor};
        font-size: 1.25rem;
        flex-shrink: 0;
        align-items: center;
        user-select: none;
        border-radius: 50%;
        justify-content: center;
        width: 3rem;
        height: 3rem;
        font-size: ${fontSizeS};
        margin-right: -4px;


    .icon {
        height: 50%;
        width: 50%;
        ${props => props.isDragging ? css`
            fill: #fff;
        ` : css`
            fill: ${props => props.chipColor};
        `}
        
        transition: fill .3s;
    }


    }

    .chip-content {
        cursor: inherit;
        display: flex;
        align-items: center;
        ${'' /* white-space: nowrap; */}
        padding-left: 1rem;
        padding-right: 1.5rem;
    }
`



export const ChartContent = styled(DefaultFlexDiv)`
    font-size: ${fontSizeXS};
    justify-content: ${props => props.justify || 'center'};
    align-items: ${props => props.align || 'flex-start'};
    height: 70%;
`

export const MetricFilters = styled(DefaultFlexDiv)`
    overflow-y: scroll;
    align-items: stretch;
`


export const MetricsFilterContent = styled(DefaultFlexDiv)`
    overflow-y: scroll;
    height: 70%;
`


export const MetricsFilterDroppable = styled(DefaultFlexDiv)`
    border-width: 1px;
    border-style:  ${props => props.isDraggingOver 
                                ? `dashed`
                                : `solid`};
    border-color:  ${props => props.border 
                                ? props.color
                                : `${ColorGreyLight}`};
                                
    border-radius: 2rem;
    height: 3rem;
    justify-content: center;
    color: ${
        props => props.border ? props.color : `${ColorGreyDark}`
    };
    ${props => props.border && css`
        background-color: ${props => props.lightColor};
    `}
    font-size: ${fontSizeS};
    font-weight: 200;
    padding: 0 1rem;
`

export const FiltersTitleContainer = styled(DefaultGridDiv)`
    grid-template-columns:  3fr 7fr;
    padding-bottom: 1rem;
    grid-gap: 1rem;
`

export const FiltersTitle = styled(DefaultFlexDiv)`
    font-size: ${fontSizeM};
    justify-content: flex-end;
`

export const FiltersDropField = styled(DefaultFlexDiv)`
    font-size: ${fontSizeS};
    justify-content: flex-end;
    align-items: stretch;
    padding-bottom: .5rem;
    position: relative;
`

export const MetricsFilterTitle = styled(DefaultFlexDiv)`
    font-size: ${fontSizeS};
    flex-direction: row;
    justify-content: space-between;
    align-items: ${props => props.chartTitle ? "flex-end" : "flex-start"};
    cursor: pointer;
    font-weight: 300;
    ${props => !props.chartTitle && css`
        margin-bottom: 1rem;
    `}

    padding: 0 1rem 0 0;

    span {
        align-self: flex-end;
    }

    &:hover > .delete-icon {
        visibility: visible; 
    }

        .delete-icon {
            visibility: hidden;
            font-weight: 400;
            color: ${colorOrange}
        }
`

export const MetricsFilterElement = styled(DefaultGridDiv)`
    grid-template-rows: 30% 70%;
    height: 40%;
    align-items: center;
    padding: 0 1rem;
    grid-gap: 0rem;
`

export const LimitMessage = styled.div`
    display: flex;
    height: 3rem;
    align-items: center;
    justify-content: center;
    color: ${colorOrange};
    font-size: ${fontSizeS};
`
